import React from 'react';
import CompareForm from './CompareForm';


class IdentityCreate extends React.Component {

    render(){
        return (
            <div>
                <CompareForm />
            </div>
        );
    }

}
export default IdentityCreate;



// WEBPACK FOOTER //
// ./src/pages/CompareScenes/CompareCreate.js